import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AddContractInterface,
  ContractInterface,
} from '../interfaces/contract.interface';
import { NextPickupInterface } from '../interfaces/nextPickup.interface';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class ContractsApiService {
  constructor(
    private storageService: StorageService,
    private apiService: ApiService,
    private http: HttpClient
  ) {}

  public getRestrictedUserData(): Promise<any> {
    const token = this.storageService.get('token');
    const lang = this.storageService.getPersistent('lang');
    const api = this.apiService.api;
    const nip = this.storageService.get('nip');

    let url = api + '/api/Zewnetrzny/Rejestracja/DanePodmiotu?';
    let urlParams = new HttpParams();
    urlParams = urlParams.set('Jezyk', lang);
    urlParams = urlParams.set('nip', nip);
    url = url + urlParams.toString();

    return this.http
      .request<any>('get', url, {
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }

  public getRestrictedWasteCodes(): Promise<any> {
    const token = this.storageService.get('token');
    const lang = this.storageService.getPersistent('lang');
    const api = this.apiService.api;

    let url = api + '/api/Zewnetrzny/BDO/KodyOdpadow?';
    let urlParams = new HttpParams();
    urlParams = urlParams.set('Jezyk', lang);
    urlParams = urlParams.set('Strona', 0);
    urlParams = urlParams.set('Ilosc', 10000);
    url = url + urlParams.toString();

    return this.http
      .request<any>('get', url, {
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }

  public getNextPickupData(
    contractUUIDs: string[]
  ): Promise<NextPickupInterface> {
    const token = this.storageService.get('token');
    const lang = this.storageService.getPersistent('lang');
    const api = this.apiService.api;
    const url = api + '/api/Odbiory/PobierzNajblizszyDlaUmow';

    return this.http
      .request<NextPickupInterface>('post', url, {
        body: {
          umowy: contractUUIDs,
        },
        params: {
          Jezyk: lang,
        },
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }

  public async getContract(
    contractData: AddContractInterface = null
  ): Promise<any> {
    let token;
    if (!contractData) {
      const kodAOK = this.storageService.get('activationData')?.kodAOK;
      const numerUmowy = this.storageService.get('numerUmowy');

      if (kodAOK && numerUmowy) {
        contractData = {
          kodAOK,
          numerUmowy,
        };
      }

      token = this.storageService.get('token');
    } else {
      token = contractData.token;
    }

    const lang = this.storageService.getPersistent('lang');
    const api = this.apiService.api;
    const url = api + '/api/Umowa/PobierzDaneUmowy';

    return this.http
      .request<ContractInterface>('get', url, {
        body: contractData,
        params: {
          Jezyk: lang,
        },
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }

  public async getContractPoints(token: string): Promise<any> {
    const lang = this.storageService.getPersistent('lang');
    const api = this.apiService.api;
    const url = api + '/api/Umowa/PobierzPunkty';
    const data = {
      strona: 0,
      iloscElementow: 1000,
    };

    return this.http
      .request('post', url, {
        body: data,
        params: {
          Jezyk: lang,
        },
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }

  public addContract(data: AddContractInterface): Promise<any> {
    const token = this.storageService.get('token');
    const lang = this.storageService.getPersistent('lang');
    const api = this.apiService.api;
    const url = api + '/api/Umowa/PobierzUmowe';

    return this.http
      .request('post', url, {
        body: data,
        params: {
          Jezyk: lang,
        },
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }

  public getContractFileList(token: string): Promise<any> {
    const lang = this.storageService.getPersistent('lang');
    const api = this.apiService.api;
    const url = api + '/api/Umowa/PobierzListePlikow';

    return this.http
      .request('get', url, {
        params: {
          Jezyk: lang,
        },
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }

  public fetchContractPDFFile(token, uuid, folder): Promise<any> {
    const lang = this.storageService.getPersistent('lang');
    const api = this.apiService.api;
    const url = `${api}/api/Umowa/${uuid}/${folder}/PobieraniePDF`;

    return this.http
      .request('get', url, {
        params: {
          Jezyk: lang,
        },
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }
}
